import React from 'react';
import { LoadingIcon, ScrollDiv } from '_components'
import { connect } from 'react-redux'
import styles from './List.module.css'
import { SpecialProgListItem } from './ListItem';

class PeerReviewSpecialProgList extends React.Component {

    render() {
        return (
            <div>
                {this.props.loading &&
                    <div className={styles.loading_container}>
                        <LoadingIcon size="small" />
                    </div>
                }
                <ScrollDiv divId={'MC_SPEC_PROG'} className={styles.message_list}>
                    {Object.keys(this.props.messages)
                        .sort((a, b) => new Date(this.props.messages[b].lastSeen) - new Date(this.props.messages[a].lastSeen))
                        .map(key => {
                            const message = this.props.messages[key];
                            return <SpecialProgListItem
                                key={message.nono}
                                id={message.nono}
                            />
                        })

                    }
                </ScrollDiv>
            </div>
        );
    }
}


function mapStateToProps(state) {
    let messages = Object.keys(state.entities.specProgReqMsgs)
        .sort((a, b) =>
            new Date(state.entities.specProgReqMsgs[a].addDate).getTime() - new Date(state.entities.specProgReqMsgs[b].addDate).getTime()
        )
        .map(x => state.entities.specProgReqMsgs[x]);

    return {
        messages,
        loading: state.ui.specProgReqMsgs.loading
    };
}

const connectedPeerReviewSpecialProgList = connect(mapStateToProps)(PeerReviewSpecialProgList);
export { connectedPeerReviewSpecialProgList as PeerReviewSpecialProgList };